export default __webpack_public_path__ + "static/media/tvs-max.c58cd665.svg";